import React from "react";
import Social from "./Socials";
import { useTranslation } from "react-i18next";

const Slider = (props) => {
  const { t } = useTranslation("clientSite");

  const heroImage = props.site.headerFilename === null
    ? process.env.PUBLIC_URL + "defaultSliderImage.jpg"
    : process.env.REACT_APP_API_SERVICE_BASE_URL + "image/SiteHeaderImages/" + props.site.headerFilename;

  const isDark = props.site.themeId === 2;
  return (
    <section
      id="home"
      className="hero"
        style={{
    backgroundImage: isDark
      ? `linear-gradient(120deg, rgba(6,10,20,.72), rgba(6,10,20,.38)), url(${heroImage})`
      : `linear-gradient(120deg, rgba(255,255,255,.08), rgba(255,255,255,0)), url(${heroImage})`
  }}
    >
      <div className="site-container hero__contentWrap">
        <div className="hero__content">
          {/* <div className="hero__badge">{props.site.siteTitle}</div> */}
          <h1 className="hero__title">{props.site.siteTitle}</h1>

          {props.site.siteNoticeEnabled ? (
            <div className="hero__notice">
              <h4>{props.site.siteNoticeTitle}</h4>
              <p>{props.site.siteNoticeDescription}</p>
            </div>
          ) : null}

          <p className="hero__text">
            {props.site.aboutUsDescription || props.site.serviceDescription || t("bookNow")}
          </p>

          <div className="hero__actions">
            <a className="site-bookBtn site-bookBtn--hero" href={`make-a-booking?id=${props.site.barberShopId}`} target="_blank" rel="noreferrer">
              {t("bookNow")}
            </a>
            <a className="hero__ghostBtn" href="#services" onClick={(e) => {
              e.preventDefault();
              const target = document.getElementById("services");
              if (!target) return;
              const header = document.querySelector(".site-header");
              const offset = (header?.offsetHeight || 88) + 12;
              const top = target.getBoundingClientRect().top + window.pageYOffset - offset;
              window.scrollTo({ top, behavior: "smooth" });
            }}>
              {t("header.nav.services")}
            </a>
          </div>

          <Social site={props.site} compact />
        </div>
      </div>
      <div className="hero__fade" />
    </section>
  );
};

export default Slider;
